import React, { useEffect } from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import dayjs from 'utiles/dayjs'

import { getAntdTheme } from './theme/antdTheme'
import english from './locales/en-US'
import french from './locales/fr-FR'
import russian from './locales/ru-RU'
import chinese from './locales/zh-CN'
import spanish from './locales/es-ES'

const locales = {
  'en-US': english,
  'fr-FR': french,
  'ru-RU': russian,
  'zh-CN': chinese,
  'es-ES': spanish,
}

const mapStateToProps = ({ settings }) => ({ settings })

const Localization = ({ children, settings: { locale, theme, altoContraste } }) => {
  const currentLocale = locales[locale] || locales['es-ES']

  useEffect(() => {
    if (currentLocale.localeMoment) {
      dayjs.updateLocale(currentLocale.localeMoment, {
        weekStart: 1, // 👈 lunes como primer día de la semana
      })
      dayjs.locale(currentLocale.localeMoment)
    }
  }, [currentLocale.localeMoment])

  return (
    // El tema se aplica aquí, en el ConfigProvider más externo, porque es donde
    // está disponible settings.theme. Los ConfigProvider anidados heredan el
    // tema, así que basta con declararlo una vez.
    <ConfigProvider locale={currentLocale.localeAntd} theme={getAntdTheme(theme, altoContraste)}>
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default connect(mapStateToProps)(Localization)
